package com.dignicate.web.data.content

import com.dignicate.web.domain.LocalizedTexts

/**
 * Company page content model
 */
data class CompanyContentDto(
    val companyName: LocalizedTexts,
    val items: List<Item>
) {
    data class Item(
        val label: LocalizedTexts,
        val sublabel: LocalizedTexts? = null,
        val value: LocalizedTexts
    )
}
